var _defs, _metadata, _rect, _g, _polygon, _g2, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "59.6195mm",
    height: "59.6195mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1365 1365",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:56.5367}\r\n    .fil0 {fill:none}\r\n    .fil1 {fill:#B18278}\r\n    .fil3 {fill:red}\r\n    .fil2 {fill:yellow}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 419l1195 0 0 298 -1195 0 0 -298z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1365,
    height: 1365
  })), /*#__PURE__*/React.createElement("g", {
    id: "_594806848"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil1 str0",
    x: 158,
    y: 264,
    width: 152,
    height: 837
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1 str0",
    x: 1055,
    y: 264,
    width: 152,
    height: 837
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "85,419 1280,419 1280,717 85,717 "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil3 str0",
    transform: "matrix(0.0787784 0.0851578 -1.7386 1.87939 1320.93 255.731)",
    width: 1365,
    height: 315
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3 str0",
    transform: "matrix(0.0787784 0.0851578 -1.7386 1.87939 869.133 255.731)",
    width: 1365,
    height: 315
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3 str0",
    transform: "matrix(0.0787784 0.0851578 -1.7386 1.87939 417.338 255.731)",
    width: 1365,
    height: 315
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "85,419 1280,419 1280,717 85,717 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.376d5c45793d9c59b747a73a0592090e.svg";
export { ForwardRef as ReactComponent };